import React, { FC } from 'react';
import cn from 'classnames';
import removeInlineStyles from 'utils/removeInlineStyles';
import styles from './HelloBar.module.scss';

interface OwnProps {
  content?: string;
  className?: string;
  cleanupContentStyles?: boolean;
}

const HelloBar: FC<OwnProps> = ({ className, content, cleanupContentStyles }) => {
  if (!content) {
    return null;
  }

  const helloBarContent = cleanupContentStyles ? removeInlineStyles(content) : content;
  return (
    <div
      className={cn(styles.helloBar, className, { [styles.styleContent]: cleanupContentStyles })}
      dangerouslySetInnerHTML={{ __html: helloBarContent }}
    />
  );
};

export default HelloBar;
